import Link from 'next/link';
import React from 'react';

const Agilecustome = () => {
    return (
        <section>
            <div className=" agile-border  overflow-hidden">
                <img src="img/border-top.svg" alt="top-border" width={'100%'} height={30} />
            </div>
            <div className="bg-textcolor section-py ">
                <div className="container lg:container md:mx-auto ">
                    <div className="grid grid-cols-2 items-start gap-10 pb-50 sm:grid-cols-1 lg:grid-cols-2">
                        <h2 className="text-white text-5xl font-bold leading-[64px] sm:text-2xl sm:leading-[32px] md:text-5xl md:leading-[64px]">
                            Your Trusted Partner in Agile Custom Software Development
                        </h2>
                        <p className="text-white text-xl leading-[30px] font-normal mb-0 sm:text-base md:text-xl">
                            Unlock the power of agile custom software development with Moweb Technologies, your go-to web and
                            mobile app development company in India & the USA. With over 15 years of industry experience, we
                            specialize in delivering cutting-edge enterprise solutions, IT consulting, mobile applications, web
                            applications, API integration, and UI/UX design services—all tailored to meet your unique business
                            needs.
                        </p>
                    </div>

                    <div className="grid grid-cols-5 items-center sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-5">
                        <div className="flex justify-between  flex-col   border-r-border_new border-r pr-[30px] sm:pl-0  lg:pl-0 sm:pr-0 lg:pr-[30px] sm:pb-5 lg:pb-0 sm:border-r-0 lg:border-r ">
                            <h3 className="text-4xl font-bold text-primary leading-[50px]">15+</h3>
                            <h4 className="text-white text-xl font-semibold leading-[30px] pb-[10px]">Years of Excellence</h4>
                            <p className="text-[17px] leading-[25px] font-normal text-para_gray mb-0 line-clamp-3 sm:text-base md:text-[17px]">
                                We bring extensive experience and deep technical expertise to every project.
                            </p>
                        </div>
                        <div className="flex justify-between  flex-col   border-r-border_new border-r px-[30px] sm:pb-5 lg:pb-0 sm:px-0 lg:px-[30px] sm:border-r-0 lg:border-r">
                            <h3 className="text-4xl font-bold text-orange_new leading-[50px]">500+</h3>
                            <h4 className="text-white text-xl font-semibold leading-[30px] pb-[10px]">Global Clients</h4>
                            <p className="text-[17px] leading-[25px] font-normal text-para_gray mb-0 line-clamp-3 sm:text-base md:text-[17px]">
                                Proudly serving businesses across the globe with tailored technology solutions.
                            </p>
                        </div>

                        <div className="flex justify-between  flex-col   border-r-border_new border-r px-[30px] sm:pb-5 lg:pb-0 sm:px-0 lg:px-[30px] sm:border-r-0 lg:border-r">
                            <h3 className="text-4xl font-bold text-green_new leading-[50px]">900+</h3>
                            <h4 className="text-white text-xl font-semibold leading-[30px] pb-[10px]">Successful Projects</h4>
                            <p className="text-[17px] leading-[25px] font-normal text-para_gray mb-0 line-clamp-3 sm:text-base md:text-[17px]">
                                Delivering quality results, time after time, to empower businesses for success.
                            </p>
                        </div>
                        <div className="flex justify-between  flex-col   px-[30px]  sm:pb-5 lg:pb-0 sm:px-0 lg:px-[30px]">
                            <h3 className="text-4xl font-bold text-yellow leading-[50px]">96%</h3>
                            <h4 className="text-white text-xl font-semibold leading-[30px] pb-[10px]">Client Retention Rate</h4>
                            <p className="text-[17px] leading-[25px] font-normal text-para_gray mb-0 line-clamp-3 sm:text-base md:text-[17px]">
                                Our clients choose to grow with us, thanks to our commitment to excellence and customer
                                satisfaction.
                            </p>
                        </div>
                        <div className="bg-border_new rounded-[10px] p-5  bg-opacity-[30%] border border-border_new">
                            <p className="fs-md leading-[30px] font-semibold text-white mb-0 pb-5">
                                Ready to transform your ideas into impactful software solutions?
                            </p>
                            <div>
                                <Link href="contact-us" className="btn btn-primary w-full">
                                    Partner with Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" agile-border-bottom overflow-hidden">
                <img src="img/border-bottom.svg" alt="bottom-border" width={'100%'} height={30} />
            </div>
        </section>
    );
};

export default Agilecustome;
